import React from 'react'
import PropTypes from 'prop-types'

import Slider from 'rc-slider'
import '../scss/ui/inputRangePicker.scss'

const InputToggle = ({ onChange, value, ...rest }) => (
    <div className="inputToggle">
        <Slider
            value={value}
            className={value > 0 ? 'on' : ''}
            onChange={val => onChange(parseInt(val, 10))}
            max={1}
            min={0}
            {...rest}
        />
    </div>
)

InputToggle.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.number.isRequired,
}

export default InputToggle



// WEBPACK FOOTER //
// ./src/ui/InputToggle.js